import { LibConfig } from "../../init";
import { getUniqueElemensById } from "../getUniqueElemensById";
export const updateAllRegions = (regions) => {
    if (regions && regions.length) {
        LibConfig.allRegions = getUniqueElemensById(LibConfig.allRegions.concat(regions));
    }
};
//# sourceMappingURL=updateAllRegions.js.map